import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Skeleton, Col, Row } from "antd";
import axios from "axios";
import LeadForm from "./LeadForm";
import { get } from "lodash";
import { withTranslation } from "react-i18next";
import LeadFormSidebar from "./LeadFormSidebar";

class LeadDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lead: {},
      requestType: get(props, "location.state.requestType", "post"),
      type: "",
      loading: true,
      btnText: "",

      tags: [],
      users: [],
      contacts: [],
      leads: {},
      task_status: [],
      task_priority: [],
      event_type: {},
      event_status: {},
      comments: {},
    };
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };
    if (this.state.requestType === "put") this.fetchSingle();
    else
      this.setState({
        loading: false,
        btnText: this.props.t("general.create", "Create"),
      });
  }

  fetchSingle = (e) => {
    const { requestType } = this.state;

    if (requestType === "put") {
      const leadID = this.props.match.params.leadID;

      let requestList = [];
      // requestList.push(
      //   axios.get(process.env.REACT_APP_AXIOS_URL + "/api/contacts_list/")
      // );
      requestList.push(
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/leads/${leadID}/`)
      );

      axios
        .all(requestList)
        .then(
          axios.spread((...responses) => {
            // const responseContacts = responses[0];
            const responseLead = responses[0];

            this.setState({
              lead: responseLead.data,
              loading: false,
              // contacts: responseContacts.data,
              btnText: this.props.t("general.update", "Update"),
            });
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
    } else if (requestType === "post") {
      this.setState({
        btnText: this.props.t("general.create", "Create"),
      });
    }
  };

  handleState = (key, value) => {
    let obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  render() {
    if (this.state.loading) {
      return (
        <div>
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
          <Skeleton active loading={this.state.loading} />
        </div>
      );
    } else {
      return (
        <div>
          {this.state.requestType === "put" ? (
            <Row gutter={16}>
              <Col md={8}>
                <LeadFormSidebar
                  lead={this.state.lead}
                  handleState={this.handleState}
                  fetchSingle={this.fetchSingle}
                  tags={this.state.tags}
                  users={this.state.users}
                  contacts={this.state.contacts}
                  task_status={this.state.task_status}
                  task_priority={this.state.task_priority}
                  event_type={this.state.event_type}
                  event_status={this.state.event_status}
                  loading={this.state.loading}
                />
              </Col>
              <Col md={16}>
                <LeadForm
                  data={this.state.lead}
                  contacts={this.state.contacts}
                  requestType={this.state.requestType}
                  btnText={this.state.btnText}
                />
              </Col>
            </Row>
          ) : (
            <Row gutter={16}>
              <Col md={24}>
                <LeadForm
                  data={this.state.lead}
                  contacts={this.state.contacts}
                  requestType={this.state.requestType}
                  btnText={this.state.btnText}
                />
              </Col>
            </Row>
          )}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(LeadDetail))
);



// WEBPACK FOOTER //
// ./src/containers/Leads/LeadDetail.js